import React from 'react';

const TextArea = (props) => {
    return (
        <div className="form-group">
            {props.label &&
                <label htmlFor={props.name}>{props.label}</label>
            }
            <textarea
                className="form-control"
                id={props.name}
                name={props.name}
                rows={props.rows || 5}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
            />
        </div>
    )
}

export default TextArea;